import React from "react";
import PollsAdminPage from "../../polls/PollsAdminPage.jsx";

export default function ManagerPolls() {
    return (
        <div className="card">
            <h1>Voting</h1>
            <PollsAdminPage />
        </div>
    );
}